/**
 * Prefixes applied to dynamic custom-field column field-ids in the Customer Master report.
 *
 * The CSV export reads these same prefixes when emitting headers, so the export
 * column names always line up with the grid column field-ids.
 */
export const CUSTOMER_MASTER_CUSTOM_FIELD_PREFIXES = Object.freeze({
  customer: 'Customer · ',
  contract: 'Contract · ',
});
